import React, { useState } from 'react';
import './Calendar.css';
import hbsLogo from '../assets/HBS_LOGO.png';
import stanfordLogo from '../assets/STANFORD_LOGO.png';
import whartonLogo from '../assets/WHARTON_LOGO.png';
import columbiaLogo from '../assets/COLUMBIA_LOGO.png';
import mitLogo from '../assets/MIT_LOGO.png';
import chicagoBoothLogo from '../assets/CHICAGO_BOOTH_LOGO.png';
import kelloggLogo from '../assets/KELLOGG_LOGO.png';
import berkeleyHaasLogo from '../assets/BERKELEY_HAAS_LOGO.png';
import yaleSomLogo from '../assets/YALE_SOM_LOGO.png';
import dardenLogo from '../assets/DARDEN_LOGO.png';
import uclaAndersonLogo from '../assets/UCLA_ANDERSON_LOGO.png';
import emoryGoizuetaLogo from '../assets/EMORY_GOIZUETA_LOGO.png';

type DeadlineRow = {
  program: string;
  appRound1?: string;
  appRound2?: string;
  appRound3?: string;
  appRound4?: string;
  notificationRound1?: string;
  notificationRound2?: string;
  notificationRound3?: string;
  notificationRound4?: string;
};

const DEADLINE_ROWS: DeadlineRow[] = [
  { program: 'Berkeley Haas Accelerated Access', appRound1: 'April 16, 2026', notificationRound1: 'June 25, 2026' },
  { program: 'Chicago Booth Scholars', appRound1: 'April 2, 2026', notificationRound1: 'June 25, 2026' },
  { program: 'Columbia Deferred Enrollment', appRound1: 'April 15, 2026', notificationRound1: 'late June 2026' },
  { program: 'HBS 2+2', appRound1: 'April 22, 2026' },
  { program: 'MIT Sloan Early Admission', appRound1: 'April 17, 2026', notificationRound1: 'June 11, 2026' },
  { program: 'Northwestern Kellogg Future Leaders', appRound1: 'April 22, 2026', notificationRound1: 'June 24, 2026' },
  { program: 'NYU Stern - NYU X', appRound1: 'June 15, 2026', notificationRound1: 'September 1, 2026' },
  { program: 'Stanford Deferred Enrollment' },
  { program: 'UCLA Anderson Deferred Enrollment', appRound1: 'April 25, 2026', notificationRound1: 'June 20, 2026' },
  { program: 'UVA Darden Future Year Scholars', appRound1: 'April 22, 2026', notificationRound1: 'June 17, 2026' },
  { program: 'Wharton Moelis Advance Access', appRound1: 'April 22, 2026', notificationRound1: 'July 1, 2026' },
  { program: 'Yale SOM Silver Scholars', appRound1: 'April 14, 2026' }
];

type CalendarEventType = 'deadline' | 'info-session' | 'workshop' | 'other';
type CalendarEvent = {
  id: string;
  title: string;
  event_date: string; // YYYY-MM-DD
  event_type: CalendarEventType;
  description?: string;
};

const HARD_CODED_EVENTS: CalendarEvent[] = [
  { id: 'app-berkeley-haas-r1', title: 'Berkeley Haas Accelerated Access - App Deadline', event_date: '2026-04-16', event_type: 'deadline' },
  { id: 'notif-berkeley-haas-r1', title: 'Berkeley Haas Accelerated Access - Notification', event_date: '2026-06-25', event_type: 'info-session', description: 'Notification Round 1' },
  { id: 'app-booth-r1', title: 'Chicago Booth Scholars - App Deadline', event_date: '2026-04-02', event_type: 'deadline' },
  { id: 'notif-booth-r1', title: 'Chicago Booth Scholars - Notification', event_date: '2026-06-25', event_type: 'info-session', description: 'Notification Round 1' },
  { id: 'app-columbia-r1', title: 'Columbia Deferred Enrollment - App Deadline', event_date: '2026-04-15', event_type: 'deadline' },
  { id: 'notif-columbia-r1', title: 'Columbia Deferred Enrollment - Notification (Late June)', event_date: '2026-06-30', event_type: 'info-session', description: 'Late June 2026 (approximate)' },
  { id: 'app-hbs-r1', title: 'HBS 2+2 - App Deadline', event_date: '2026-04-22', event_type: 'deadline' },
  { id: 'app-mit-r1', title: 'MIT Sloan Early Admission - App Deadline', event_date: '2026-04-17', event_type: 'deadline' },
  { id: 'notif-mit-r1', title: 'MIT Sloan Early Admission - Notification', event_date: '2026-06-11', event_type: 'info-session', description: 'Notification Round 1' },
  { id: 'app-kellogg-r1', title: 'Northwestern Kellogg Future Leaders - App Deadline', event_date: '2026-04-22', event_type: 'deadline' },
  { id: 'notif-kellogg-r1', title: 'Northwestern Kellogg Future Leaders - Notification', event_date: '2026-06-24', event_type: 'info-session', description: 'Notification Round 1' },
  { id: 'app-nyu-r1', title: 'NYU Stern - NYU X - App Deadline', event_date: '2026-06-15', event_type: 'deadline' },
  { id: 'notif-nyu-r1', title: 'NYU Stern - NYU X - Notification', event_date: '2026-09-01', event_type: 'info-session', description: 'Notification Round 1' },
  { id: 'app-ucla-r1', title: 'UCLA Anderson Deferred Enrollment - App Deadline', event_date: '2026-04-25', event_type: 'deadline' },
  { id: 'notif-ucla-r1', title: 'UCLA Anderson Deferred Enrollment - Notification', event_date: '2026-06-20', event_type: 'info-session', description: 'Notification Round 1' },
  { id: 'app-uva-r1', title: 'UVA Darden Future Year Scholars - App Deadline', event_date: '2026-04-22', event_type: 'deadline' },
  { id: 'notif-uva-r1', title: 'UVA Darden Future Year Scholars - Notification', event_date: '2026-06-17', event_type: 'info-session', description: 'Notification Round 1' },
  { id: 'app-wharton-r1', title: 'Wharton Moelis Advance Access - App Deadline', event_date: '2026-04-22', event_type: 'deadline' },
  { id: 'notif-wharton-r1', title: 'Wharton Moelis Advance Access - Notification', event_date: '2026-07-01', event_type: 'info-session', description: 'Notification Round 1' },
  { id: 'app-yale-r1', title: 'Yale SOM Silver Scholars - App Deadline', event_date: '2026-04-14', event_type: 'deadline' }
];

const SCHOOL_LOGOS: Array<{ key: string; logoSrc: string; alt: string }> = [
  { key: 'berkeley haas', logoSrc: berkeleyHaasLogo, alt: 'Berkeley Haas logo' },
  { key: 'chicago booth', logoSrc: chicagoBoothLogo, alt: 'Chicago Booth logo' },
  { key: 'columbia', logoSrc: columbiaLogo, alt: 'Columbia logo' },
  { key: 'hbs', logoSrc: hbsLogo, alt: 'Harvard Business School logo' },
  { key: 'harvard business school', logoSrc: hbsLogo, alt: 'Harvard Business School logo' },
  { key: 'mit sloan', logoSrc: mitLogo, alt: 'MIT Sloan logo' },
  { key: 'kellogg', logoSrc: kelloggLogo, alt: 'Kellogg logo' },
  { key: 'stanford', logoSrc: stanfordLogo, alt: 'Stanford logo' },
  { key: 'ucla', logoSrc: uclaAndersonLogo, alt: 'UCLA Anderson logo' },
  { key: 'uva darden', logoSrc: dardenLogo, alt: 'UVA Darden logo' },
  { key: 'darden', logoSrc: dardenLogo, alt: 'UVA Darden logo' },
  { key: 'wharton', logoSrc: whartonLogo, alt: 'Wharton logo' },
  { key: 'yale', logoSrc: yaleSomLogo, alt: 'Yale SOM logo' },
  { key: 'emory goizueta', logoSrc: emoryGoizuetaLogo, alt: 'Emory Goizueta logo' }
];

const Calendar: React.FC = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const events = HARD_CODED_EVENTS;

  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  const getEventTypeSymbol = (type: string) => {
    switch (type) {
      case 'deadline':
        return '★';
      case 'info-session':
        return '■';
      case 'workshop':
        return '●';
      default:
        return '▲';
    }
  };

  const getDaysInMonth = (date: Date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay();

    const days = [];
    for (let i = 0; i < startingDayOfWeek; i++) days.push(null);
    for (let day = 1; day <= daysInMonth; day++) days.push(new Date(year, month, day));
    return days;
  };

  const toYmd = (value: unknown) => {
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
    const d = value instanceof Date ? value : new Date(value as any);
    if (Number.isNaN(d.getTime())) return '';
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const getEventsForDate = (date: Date) => {
    const dateString = toYmd(date);
    return events.filter((event) => toYmd(event.event_date) === dateString);
  };

  const navigateMonth = (direction: 'prev' | 'next' | 'current') => {
    const newDate = new Date(currentDate);
    if (direction === 'prev') newDate.setMonth(newDate.getMonth() - 1);
    else if (direction === 'next') newDate.setMonth(newDate.getMonth() + 1);
    else newDate.setTime(Date.now());
    setCurrentDate(newDate);
  };

  const getEventTypeLabel = (type: string) => {
    switch (type) {
      case 'deadline':
        return 'Application Deadlines';
      case 'info-session':
        return 'Info Sessions/Webinars';
      case 'workshop':
        return 'Workshops/Prep Sessions';
      default:
        return 'Other Events';
    }
  };

  const getLogoForText = (text: string) => {
    const normalized = text.toLowerCase();
    const match = SCHOOL_LOGOS.find((entry) => normalized.includes(entry.key));
    return match || null;
  };

  const days = getDaysInMonth(currentDate);
  const cell = (value?: string) => value || '';

  return (
    <div className="calendar-page">
      <div className="calendar-container">
        <div className="calendar-header">
          <div className="calendar-heading">
            <h1 className="calendar-title">Application Calendar</h1>
            <p className="calendar-subtitle">
              Track deferred MBA deadlines, notifications, and key admissions milestones in one place.
            </p>
          </div>
          <div className="calendar-actions">
            <div className="month-navigation">
              <button className="nav-button prev" onClick={() => navigateMonth('prev')}>Previous</button>
              <button className="nav-button current" onClick={() => navigateMonth('current')}>Current</button>
              <button className="nav-button next" onClick={() => navigateMonth('next')}>Next</button>
            </div>
          </div>
        </div>

        <div className="calendar-month-header">
          <h2 className="month-year">
            {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
          </h2>
        </div>

        <div className="calendar-grid">
          <div className="calendar-weekdays">
            {dayNames.map((day) => (
              <div key={day} className="weekday">{day}</div>
            ))}
          </div>

          <div className="calendar-days">
            {days.map((day, index) => {
              if (!day) return <div key={index} className="calendar-day empty"></div>;
              const dayEvents = getEventsForDate(day);
              const isToday = day.toDateString() === new Date().toDateString();
              return (
                <div
                  key={index}
                  className={`calendar-day ${isToday ? 'today' : ''}`}
                >
                  <div className="day-number">{day.getDate()}</div>
                  <div className="day-events">
                    {dayEvents.map((event) => (
                      <div
                        key={event.id}
                        className="event"
                        style={{ backgroundColor: '#7DD3FC' }}
                        title={event.description}
                      >
                        {(() => {
                          const logo = getLogoForText(event.title);
                          return (
                            <>
                              {logo && (
                                <img
                                  src={logo.logoSrc}
                                  alt={logo.alt}
                                  className="event-logo"
                                />
                              )}
                              <span className="event-text">
                                {getEventTypeSymbol(event.event_type)} {event.title}
                              </span>
                            </>
                          );
                        })()}
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="calendar-legend">
          <h3>Event Types</h3>
          <div className="legend-items">
            {(['deadline', 'info-session', 'workshop', 'other'] as const).map((type) => {
              const symbol = type === 'deadline' ? '★' : type === 'info-session' ? '■' : type === 'workshop' ? '●' : '▲';
              return (
                <div key={type} className="legend-item">
                  <span className="legend-symbol" aria-hidden="true">{symbol}</span>
                  <span className="legend-label">{getEventTypeLabel(type)}</span>
                </div>
              );
            })}
          </div>
        </div>

        <div className="calendar-table-section">
          <div className="calendar-table-wrap">
            <table className="calendar-table" aria-label="2025-2026 Deferred MBA application deadlines and notifications">
              <thead>
                <tr>
                  <th rowSpan={2}>MBA Program</th>
                  <th colSpan={4}>2025-2026 Deferred MBA Application Deadline</th>
                  <th colSpan={4}>Notification</th>
                </tr>
                <tr>
                  <th>Round 1</th><th>Round 2</th><th>Round 3</th><th>Round 4</th>
                  <th>Round 1</th><th>Round 2</th><th>Round 3</th><th>Round 4</th>
                </tr>
              </thead>
              <tbody>
                {DEADLINE_ROWS.map((row) => (
                  <tr key={row.program}>
                    <td>
                      <div className="calendar-program-cell">
                        {(() => {
                          const logo = getLogoForText(row.program);
                          return (
                            <>
                              {logo && (
                                <img
                                  src={logo.logoSrc}
                                  alt={logo.alt}
                                  className="calendar-program-logo"
                                />
                              )}
                              <span>{row.program}</span>
                            </>
                          );
                        })()}
                      </div>
                    </td>
                    <td>{cell(row.appRound1)}</td>
                    <td>{cell(row.appRound2)}</td>
                    <td>{cell(row.appRound3)}</td>
                    <td>{cell(row.appRound4)}</td>
                    <td>{cell(row.notificationRound1)}</td>
                    <td>{cell(row.notificationRound2)}</td>
                    <td>{cell(row.notificationRound3)}</td>
                    <td>{cell(row.notificationRound4)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calendar;
